import React, { useState, useEffect } from 'react';
import { Link, withRouter, useLocation } from 'react-router-dom';
import { TextBoxComponent, NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import axios from "axios";
import { Fetch, FetchFileUpload } from "../services/dataservice";
import { connect } from 'react-redux';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function UpdatePetProfile({ history, custInfo }) {
    const cId = parseInt(custInfo.map((item) => item.custId));    
    const location = useLocation();
    const [selectedFile, setSelectedFile] = useState(null);
    const [petData, setPetData] = useState({
        petID: location.state,
        customerID: cId,
        petName: null,
        petType: null,
        breed: null,
        ageYear: 0,
        ageMonth: 0,
        weight: 0,
        color: null,
        gender: null,
        imageName: null
    });
    const gender = [
        { Id: 1, Type: 'Male' },
        { Id: 2, Type: 'Female' }        
    ];
    const petType = [
        { Id: 1, Type: 'Cat' },
        { Id: 2, Type: 'Dog' }        
    ];
    const genderfields = { text: 'Type', value: 'Type' };
    const petTypefields = { text: 'Type', value: 'Type' };
    
    useEffect(() => {
        if (petData.petID > 0) {
            axios
                .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/PetInformation/GetById/` + petData.petID)
                .then((response) => {
                    setPetData(response.data);
                });
        }
    }, []);

    const handleChange = (e, property) => {
        setPetData({ ...petData, [property]: e.target.value });
    };
    const handleChangeInt = (e, property) => {
        setPetData({ ...petData, [property]: parseInt(e.target.value) });
    };
    const handleChangeFloat = (e, property) => {
        setPetData({ ...petData, [property]: parseFloat(e.target.value) });
    };
    const handleFileChange = e => { 
        setSelectedFile(e.target.files[0]);      
    };


    // const uploadFiles = async () => {
    //     var result1 = await Fetch(`/File/Upload`, "post", selectedFile);        
    // };


    const handleUpdatePetProfile = async () => {
        try {
            //uploadFiles();
            if (selectedFile) {
                const formData = new FormData()
                formData.append('file', selectedFile, selectedFile.name)   //the name 'file' must match the name of the parameter in the controller's action                
                let result = await FetchFileUpload(`/File/Upload`, "post", formData);
                if (result.status == 'success') {
                    petData.imageName = selectedFile.name;
                }
            } 
            // else {
            //     alert('Select an image.');
            // }                    
        
            if (petData.petID > 0) {
                let result = await Fetch(`/PetInformation/Update`, "put", petData);
                if (result > 0) {
                    alert("Updated successfully.");
                }
            } else {
                let result = await Fetch(`/PetInformation/Add`, "post", petData);
                if (result > 0) {
                    petData.petID = result;
                    alert("Updated successfully.");
                }
            }
            history.push("/member/pet-profile");
        }
        catch (ex) {
            alert("Error...");
        }
    };

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Update Pet Profile
                            {/* <Link style={{ fontSize: '15px', float: 'right' }} to="/member/pet-profile"><i class="fa fa-arrow-left" style={{ color: "#f19f1f" }} aria-hidden="true"></i>&nbsp;&nbsp;Back</Link> */}
                        </h3>
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Pet Name</label>
                        <TextBoxComponent cssClass="e-outline" value={petData.petName} onChange={(e) => handleChange(e, "petName")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Pet Type</label>
                        <DropDownListComponent                            
                            cssClass="e-outline"
                            dataSource={petType}
                            fields={petTypefields}
                            value={petData.petType}
                            onChange={(e) => handleChange(e, "petType")}
                            placeholder="---Select---"                            
                        />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Breed</label>
                        <TextBoxComponent cssClass="e-outline" value={petData.breed} onChange={(e) => handleChange(e, "breed")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Gender</label>
                        <DropDownListComponent                            
                            cssClass="e-outline"
                            dataSource={gender}
                            fields={genderfields}
                            value={petData.gender}
                            onChange={(e) => handleChange(e, "gender")}
                            placeholder="---Select---"                            
                        />                        
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Age: Year</label>
                        <NumericTextBoxComponent format='###' min={0} cssClass="e-outline" value={petData.ageYear} onChange={(e) => handleChangeInt(e, "ageYear")} />
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Month</label>
                        <NumericTextBoxComponent format='###' min={0} max={11} cssClass="e-outline" value={petData.ageMonth} onChange={(e) => handleChangeInt(e, "ageMonth")} />
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Weight</label>
                        <NumericTextBoxComponent format='###.## lb' min={0} max={500} validateDecimalOnType={true} decimals={2}
                            cssClass="e-outline" value={petData.weight} onChange={(e) => handleChangeFloat(e, "weight")} />
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Color</label>
                        <TextBoxComponent cssClass="e-outline" value={petData.color} onChange={(e) => handleChange(e, "color")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Upload Pet Image(only .jpg or .png)</label>                    
                        <input className="browse-img" type="file" onChange={handleFileChange} />
                        <p style={{ fontSize: '14px' }}>Pet Image:&nbsp;
                            <Popup trigger={<a style={{cursor:'pointer'}}>{petData.imageName}</a>} position="right center">
                            {close => (
                                <div>
                                    <img src={process.env.REACT_APP_IMAGE_URL + petData.imageName} width="100%" />
                                    <a className="close" onClick={close}>&times;</a>
                                </div>
                            )}
                            </Popup>
                            {/* <Link style={{color: '#ef5030'}} to={{ pathname: process.env.REACT_APP_IMAGE_URL + petData.imageName }} target='_blank'>{petData.imageName}</Link> */}
                        </p>
                    </div>                    
                    <div class="col-md-12 form-group">
                        <button className="btn btn-block btn-primary" onClick={handleUpdatePetProfile}>Update Pet Profile</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = ({ login: { custInfo } }) => ({
    custInfo
})

export default connect(mapStateToProps)(withRouter(UpdatePetProfile));